function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M17.1015,31h-6.90149v-14h6.90149c1.20551-1.35913,2.75195-2.40417,4.51031-3H8.70001c-.42499,0-.78119,.14368-1.06854,.43097-.28766,.28772-.43146,.64404-.43146,1.06903v4.5h-3.20001v8h3.20001v4.5c0,.42499,.1438,.78119,.43146,1.06848,.28735,.28766,.64355,.43152,1.06854,.43152h12.9118c-1.75836-.59583-3.30481-1.64087-4.51031-3Z"
}), React.createElement("path", {
  d: "M43.56903,14.43097c-.28772-.28729-.64404-.43097-1.06903-.43097h-14.11182c1.75836,.59583,3.30481,1.64087,4.51031,3h6.1015v14h-6.1015c-1.20551,1.35913-2.75195,2.40417-4.51031,3h14.11182c.42499,0,.78131-.14386,1.06903-.43152,.28729-.28729,.43097-.64349,.43097-1.06848V15.5c0-.42499-.14368-.78131-.43097-1.06903Z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M23.8,26.9c0-.46667,.00833-.925,.025-1.375s.14167-.875,.375-1.275c.33333-.56667,.75833-1.05,1.275-1.45s.95833-.86667,1.325-1.4c.1-.13333,.21667-.51667,.35-1.15,0-.56667-.21667-1.03333-.65-1.4s-.93333-.55-1.5-.55-1.06667,.18333-1.5,.55-.73333,.83333-.9,1.4l-2.2-.95c.33333-1,.91667-1.8,1.75-2.4s1.78333-.9,2.85-.9c1.23333,0,2.30833,.4,3.225,1.2s1.375,1.8,1.375,3c0,.36667-.05,.70833-.15,1.025s-.25,.60833-.45,.875c-.36667,.53333-.8,1.00833-1.3,1.425-.5,.41667-.9,.90833-1.2,1.475-.2,.36667-.3,1-.3,1.9h-2.4Z"
}), React.createElement("path", {
  d: "M25,32c-.46667,0-.86667-.15833-1.2-.475s-.5-.70833-.5-1.175,.16667-.86667,.5-1.2,.73333-.5,1.2-.5,.85833,.16667,1.175,.5,.475,.73333,.475,1.2-.15833,.85833-.475,1.175-.70833,.475-1.175,.475Z"
}));

var SvgWebappIconBatteryUnknownLightTheme = function SvgWebappIconBatteryUnknownLightTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconBatteryUnknownLightTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-battery-unknown-light-theme.7243873b.svg";
export { ForwardRef as ReactComponent };